import { HStack, VStack } from '@web/components/atoms/Layout'
import { Tag } from '@web/components/atoms/Tag'
import { Body2 } from '@web/components/atoms/Typography'
import { useColorWithOpacity } from '@web/components/molecules/ColorPicker/utils'
import { DESKTOP_CONTAINER_QUERY } from '@web/components/page-components/utils'
import { useVirtualGiftSection } from '@web/components/page-components/VirtualGiftSection/VirtualGiftSectionProvider'
import { useBrandingsStore } from '@web/components/utils/branding/useBrandingsStore'
import { usePageStore } from 'apps/fe-donation/libs/hooks/usePageStore'
import { pluralize } from './utils'

type VirtualGiftMatchedGivingProps = {}

const VirtualGiftMatchedGiving = (props: VirtualGiftMatchedGivingProps) => {
  const primaryColorFromBranding = useBrandingsStore(({ colorData }) => colorData['Brand'])
  const activeMatchedGiving = usePageStore((state) => state.activeMatchedGiving)!
  const context = useVirtualGiftSection()
  const styles = context.settings.styles.paymentForm?.styles
  const accentColor = useColorWithOpacity(
    styles?.matchedGivingAccentColor,
    styles?.matchedGivingAccentColorOpacity,
    styles?.accentColor ?? primaryColorFromBranding,
  )

  const activeRound = activeMatchedGiving.rounds[activeMatchedGiving.activeRound]
  const itemName = context.settings?.styles?.options?.name || 'Item'

  if (!activeRound) {
    return null
  }

  const matchedQuantity = context.quantity * activeRound.multiplier

  return (
    <VStack
      w="100%"
      bgColor="#FFF"
      borderRadius="6px"
      alignItems="center"
      css={{
        padding: '8px',
        [DESKTOP_CONTAINER_QUERY]: {
          padding: '8px 36px',
        },
      }}
    >
      <Tag bgColor={accentColor} color="#FFF" size="lg" fontWeight={700}>
        Double your impact
      </Tag>
      <HStack>
        <Body2 whiteSpace="nowrap" as="strong" fontWeight={700} fontSize="lg">
          {context.quantity} {pluralize(itemName, context.quantity)}
        </Body2>
        <Body2 fontSize="lg">=</Body2>
        <Body2 as="strong" fontWeight={700} color={accentColor} fontSize="lg">
          {matchedQuantity} {pluralize(itemName, matchedQuantity)} Filled
        </Body2>
      </HStack>
    </VStack>
  )
}

export default VirtualGiftMatchedGiving
